// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// 兼容
import '@babel/polyfill';
import 'es6-promise/auto';
import 'fetch-ie8';
import Vue from 'vue';
import App from './App';
import { sync } from 'vuex-router-sync';
import store from './store';
import router from './router';
import Element from 'element-ui';
import { install } from '../../plugin-api/src/index';
import resource from '@lib/resource.js';
import vueJsonp from 'vue-jsonp';
// 百度埋点
import * as trackEvent from '../../lib/trackEvent';
// api 请求
import ResourceApi from '../../resource-api/index';
// 饿了么 表单验证
import * as eleValidate from '../../lib/eleValidate';
// 全局
import './assets/layout.less';

// 极验人机校验
import '../../lib/gt.js'; // 有window.Geetest方法

// ** 引入动画
// import '@lib/transitions.js';

sync(store, router);
// this.$message({customClass: 'el-msg--error', message: '', type: 'error'});
// this.$message({customClass: 'el-msg--success', message: '', type: 'success'});

if (process.env.NODE_ENV === 'production') {
  // arms
  const BrowerLogger = require('alife-logger');
  const __bl = BrowerLogger.singleton({
    pid: 'fkmlak58tj@e717308128fe396',
    imgUrl: 'https://arms-retcode.aliyuncs.com/r.png?',
    tag: '标准签',
    enableSPA: true,
    disableHook: true,
    useFmp: true,
    sendResource: true
  });
}

// fundebug
// const fundebug = require('fundebug-javascript');

// fundebug.apikey = '7d07b7b2a31a6b8d5d3250a4b46c0e59289ee2307a3dbf732bd4f0d577e9cdfe';

// function formatComponentName(vm) {
//   if (vm.$root === vm) return 'root';

//   var name = vm._isVue ? (vm.$options && vm.$options.name) || (vm.$options && vm.$options._componentTag) : vm.name;
//   return (name ? 'component <' + name + '>' : 'anonymous component') + (vm._isVue && vm.$options && vm.$options.__file ? ' at ' + (vm.$options && vm.$options.__file) : '');
// }

// Vue.config.errorHandler = function(err, vm, info) {
//   var componentName = formatComponentName(vm);
//   var propsData = vm.$options && vm.$options.propsData;

//   fundebug.notifyError(err,
//   {
//       metaData:
//       {
//           componentName: componentName,
//           propsData: propsData,
//           info: info
//       }
//    });
// };

// ** Vue注入组件-
Vue.use(Element);
Vue.use(install);
// 全局引入vue-jsonp
Vue.use(vueJsonp);
// 百度统计
Vue.prototype.trackEvent = trackEvent.trackEvent;
// 接口请求api
Vue.prototype.$api = ResourceApi;
// 校验
Vue.prototype.$vla = eleValidate;
// axios http拦截
resource();
Vue.config.productionTip = false;
Vue.config.devtools = true;
/* eslint-disable no-new */
/**
 * 创建vue实例
 * 在这里注入 router  store 到所有的子组件
 * 这样就可以在任何地方使用 `this.$router` and `this.$store`
 */
new Vue({
  el: '#app',
  store,
  router,
  render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/pages/admin/main.js